/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="uiControlReference" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lowerLimit" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="upperLimit" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;choice&gt; &lt;sequence&gt; &lt;element name="staticValueSelector" type="{}valueType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}queryValueSelector" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;element name="refDrillGroup" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/choice&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Prompt extends ObjectType{

	parameterName = null;

	uiControlReference = null;

	lowerLimit = null;

	upperLimit = null;

	staticValueSelector = null;

	queryValueSelector = null;

	refDrillGroup = null;



	/**
	 * Gets the value of the parameterName property.
	 * @return {String} possible object is {@link String}
	 */
	getParameterName() {
		return this.parameterName;
	}

	/**
	 * Sets the value of the parameterName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setParameterName(value) {
		var oldValue = this.parameterName;
		this.parameterName = value;
		this._setAndNotify(154, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the uiControlReference property.
	 * @return {String} possible object is {@link String}
	 */
	getUiControlReference() {
		return this.uiControlReference;
	}

	/**
	 * Sets the value of the uiControlReference property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUiControlReference(value) {
		var oldValue = this.uiControlReference;
		this.uiControlReference = value;
		this._setAndNotify(260, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the lowerLimit property.
	 * @return {String} possible object is {@link String}
	 */
	getLowerLimit() {
		return this.lowerLimit;
	}

	/**
	 * Sets the value of the lowerLimit property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLowerLimit(value) {
		var oldValue = this.lowerLimit;
		this.lowerLimit = value;
		this._setAndNotify(261, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the upperLimit property.
	 * @return {String} possible object is {@link String}
	 */
	getUpperLimit() {
		return this.upperLimit;
	}

	/**
	 * Sets the value of the upperLimit property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUpperLimit(value) {
		var oldValue = this.upperLimit;
		this.upperLimit = value;
		this._setAndNotify(262, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the staticValueSelector property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the staticValueSelector property. <p> For example, to add a new item, do as follows: <pre> getStaticValueSelector().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValueType}
	 */
	getStaticValueSelector() {
		if (!this.staticValueSelector) {
			this.staticValueSelector = [];
		}
		return this.staticValueSelector;
	}

	/**
	 * Gets the value of the queryValueSelector property.
	 * @return {QueryValueSelector} possible object is {@link QueryValueSelector}
	 */
	getQueryValueSelector() {
		return this.queryValueSelector;
	}

	/**
	 * Sets the value of the queryValueSelector property.
	 * @param {QueryValueSelector} value allowed object is {@link QueryValueSelector}
	 */
	setQueryValueSelector(value) {
		var oldValue = this.queryValueSelector;
		this.queryValueSelector = value;
		this._setAndNotify(264, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the refDrillGroup property.
	 * @return {String} possible object is {@link String}
	 */
	getRefDrillGroup() {
		return this.refDrillGroup;
	}

	/**
	 * Sets the value of the refDrillGroup property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRefDrillGroup(value) {
		var oldValue = this.refDrillGroup;
		this.refDrillGroup = value;
		this._setAndNotify(265, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>staticValueSelector</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ValueType</code> elements, or <code>null</code> if not set
	 */
	basicGetStaticValueSelector() {
		return this.staticValueSelector;
	}

	/**
	 * Creates a new instance of <code>Prompt</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Prompt</code> object from.
	 * @return {Prompt} an object of type <code>Prompt</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createPrompt();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addStaticValueSelectorAt(position, item) {
		this._addAtAndNotify(this.getStaticValueSelector(), position, item, 263, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addStaticValueSelector(item) {
		this.addStaticValueSelectorAt(this.getStaticValueSelector().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeStaticValueSelectorAt(position) {
		this._removeAtAndNotify(this.getStaticValueSelector(), position, 263, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeStaticValueSelector(item) {
		var i = this.getStaticValueSelector().indexOf(item);
		if (i >= 0) {
			this.removeStaticValueSelectorAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Prompt";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 154, "parameterName", null));
		featureList.push(this.createFeature(false, false, false, 260, "uiControlReference", null));
		featureList.push(this.createFeature(false, false, false, 261, "lowerLimit", null));
		featureList.push(this.createFeature(false, false, false, 262, "upperLimit", null));
		var clazz;
		if (factory) {
			clazz = factory.createValueType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 263, "staticValueSelector", clazz));
		if (factory) {
			clazz = factory.createQueryValueSelector().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 264, "queryValueSelector", clazz));
		featureList.push(this.createFeature(false, false, false, 265, "refDrillGroup", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 154:
			this.setParameterName((value));
			break;
		case 260:
			this.setUiControlReference((value));
			break;
		case 261:
			this.setLowerLimit((value));
			break;
		case 262:
			this.setUpperLimit((value));
			break;
		case 264:
			this.setQueryValueSelector((value));
			break;
		case 265:
			this.setRefDrillGroup((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 263:
			this.staticValueSelector = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 260:
			return this.getUiControlReference();
		case 261:
			return this.getLowerLimit();
		case 262:
			return this.getUpperLimit();
		case 263:
			return this.getStaticValueSelector();
		case 264:
			return this.getQueryValueSelector();
		case 265:
			return this.getRefDrillGroup();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 260:
			return this.getUiControlReference();
		case 261:
			return this.getLowerLimit();
		case 262:
			return this.getUpperLimit();
		case 263:
			return this.basicGetStaticValueSelector();
		case 264:
			return this.getQueryValueSelector();
		case 265:
			return this.getRefDrillGroup();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 263:
			this.addStaticValueSelectorAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 263:
			this.addStaticValueSelector((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 263:
			this.removeStaticValueSelectorAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 263:
			this.removeStaticValueSelector((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Prompt.js